import { Table, Button, Space, Tag, Modal, Input, Form, Select, Typography, Upload, Drawer, Flex, Dr, message, notification } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { EditOutlined, PauseOutlined, DeleteOutlined, InfoOutlined, UploadOutlined, CheckCircleOutlined, StopOutlined, InboxOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import WorkflowManagementAPI from '../../../restAPI/WorkflowManagementAPI';
import CommonSkeletonLoader from '../../../helperComponents/CommonSkeleton';

const { Search, TextArea } = Input;
const { Text } = Typography;
const { Dragger } = Upload;

export default function ToDo({ tabValue, searchText }) {
    const tabKey = 1;
    const [actionForm] = Form.useForm();
    //console.log(searchText)

    const [payload, setPayload] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [count, setCount] = useState(0);
    const [levelList, setLevelList] = useState([]);
    const [clickedObject, setClickedObject] = useState("");
    const [needMoreInfoFieldsVisibility, setNeedMoreInfoFieldsVisibility] = useState(true);
    const [isStateChanged, setIsStateChanged] = useState(false);
    const [tempToDoData, setTempToDoData] = useState([]);

    const [actionButtontype, setActionButtonType] = useState(0);
    const [actionButtonName, setActionButtonName] = useState('');
    const [imageObjectFormData, setObjectFormData] = useState();

    const [currentCompanyInfo, setCurrentCompanyInfo] = useState({})

    const navigate = useNavigate(); // Initialize the useNavigate hook
    const { companyId, token, userId, userCompany } = useSelector(state => state.auth);

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isToDoListLoading, setIsToDoListLoading] = useState(false);
    const showDrawer = () => {
        setIsDrawerOpen(true);
        actionForm.resetFields();
    };

    const handleClose = () => {
        setIsDrawerOpen(false);
        actionForm.resetFields();
    };
    const [api, contextHolder] = notification.useNotification();
    const openNotification = (type, message, description, placement) => {
      api[type]({
        message: message,
        description: description,
        placement
      });
    };


    useEffect(() => {
        setIsToDoListLoading(true);
        getApprovalRequestsData();
    }, [companyId, tabValue]);
    
    useEffect(() => {
        getApprovalRequestsData();
    }, [isStateChanged]);

    const columns = [
        {
            title: 'Circulated On',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text) => {
                const date = new Date(text);
                const dateString = date.toLocaleDateString();
                const timeString = date.toLocaleTimeString();
                return (
                    <span>
                        {dateString}
                        <br />
                        {timeString}
                    </span>
                );
            },
        },
        {
            title: 'Initiator',
            dataIndex: ['createdBy', 'name'],
            //key: ['createdBy','name'],
        },
        {
            title: 'Subject Line',
            dataIndex: 'subject',
            key: 'subject',
        },
        {
            title: 'Request Type',
            dataIndex: ['requestType', 'requestType'],
            //key: 'requestType',
        },
        {
            title: 'Information',
            dataIndex: 'info',
            key: 'info',
        },
        {
            title: 'Circulation Type',
            key: 'circulationType',
            align: 'center',
            render: (_, record) => (
                <Space size="middle">
                    {record.circulationType === 'hierarchy' && <Tag color="success"> Hierarchical </Tag>}
                    {record.circulationType === 'parallel' && <Tag color="warning"> Parellel </Tag>}
                </Space>
            ),
        },
        {
            title: 'Status',
            key: 'approvalStatus',
            align: 'center',
            width: 150,
            render: (_, record) => (
                <Space size="middle">
                    {record.approvalStatus === 'approved' && <Tag color="success"> Approved </Tag>}
                    {record.approvalStatus === 'rejected' && <Tag color="error"> Rejected </Tag>}
                    {record.approvalStatus === 'pending' && <Tag color="warning"> Pending </Tag>}
                    {record.approvalStatus === 'draft' && <Tag color="yellow"> Pending </Tag>}
                </Space>
            ),
        },
        {
            title: 'Action',
            key: 'actionButtons',
            align: 'center',
            width: 150,
            render: (_, record) => (
                <Space size="middle">
                    <Button onClick={() => onClickApproveButton(record)} icon={<CheckCircleOutlined />} style={{ display: approveButton(record) ? 'inline-block' : 'none' }} type="primary" title='Approve' />
                    <Button onClick={() => onClickRejectButton(record)} icon={<StopOutlined />} style={{ display: rejectButton(record) ? 'inline-block' : 'none' }} danger type="primary" title='Reject' />
                    <Button onClick={() => onClickNeedMoreInfoButton(record)} icon={<InfoOutlined />} style={{ display: needMoreInfoButton(record) ? 'inline-block' : 'none' }} type="default" title='Need for Information' />

                </Space>
            ),
        },
    ];

    function getApproverIdMatchingParentID(param1, list){
        for (const element of list) {
            if(element['_id'] == param1){
                if(element['permission'] == 'view'){
                    return false
                }
            }
        }
        return true
    }

    const getApprovalRequestsData = async () => {
        var userRole = 0;
        const companyInfo = userCompany.companyData.find(company => company.companyId === companyId);
        await WorkflowManagementAPI.getToDoRequests(companyId, token).then((res) => {
            setCurrentCompanyInfo(companyInfo);

            var dataList = res.data
            dataList.forEach(element => {
                let changeDate = new Date(element['createdAt']).toLocaleString()
                element['createdAt'] = changeDate
                element['approvers'].forEach(elementApprover => {

                    if (elementApprover['approverResponseTime'] != null) {
                        let changeDateApprover = new Date(elementApprover['approverResponseTime']).toLocaleString()
                        elementApprover['approverResponseTime'] = changeDateApprover
                    }
                });

                //debugger
                if (companyInfo['userDetailsId'] == element['createdBy']['_id']) {//Initiator
                    if (element['permission'] == 'approve') {
                        userRole = 2; //Approver
                    } else {
                        userRole = 1;
                    }
                }
                else {
                    if (getApproverIdMatchingParentID(element['parentEntryId'], element['approvers'])) {
                        userRole = 2; //Approver
                    } else {
                        userRole = 3; //Viewer
                    }
                }
                element["userRole"] = userRole;
                element["tabKey"] = 2; //InProgress
            });
            setPayload(dataList)
            setTempToDoData(dataList)
            setIsToDoListLoading(false);
        }).catch((err) => {
            setIsToDoListLoading(false);
            console.log("Error getting ApprovalRequestsData :", err.message);
        }).finally(() => {

        })
    };

    function approveButton(data) {
        if (data['userRole'] == 1) {
            return false; //changed new
        } else if (data['userRole'] == 2) {
            return true;
        } else {
            return false;
        }
    }

    function rejectButton(data) {
        if (data['userRole'] == 1) {
            return false; //changed new
        } else if (data['userRole'] == 2) {
            return true;
        } else {
            return false;
        }
    }

    function needMoreInfoButton(data) {
        if (data['userRole'] == 1) {
            return false; //changed new
        } else if (data['userRole'] == 2) {
            return true;
        } else if (data['userRole'] == 3) {
            return false;
        } 
    }

    const handleRowClick = async (record, columnName) => {
        if (columnName === 7) {
        } else {
            if (record.userRole == 1) { //Initator
                navigate('/work-flow/initiator-view', { state: { objectDataToInitiatorView: record } })
            } else if (record.userRole == 3) { //Viewer
                // navigate('/work-flow/view-circuler', { state: { objectDataToFullCirculerView: record } })
                navigate('/work-flow/view-circuler', { state: { tabValue: tabValue, approvalId: record._id } })

                var formData = {
                    isViewed: true
                }
                await WorkflowManagementAPI.updateApproverViewStatus(record._id, record.parentEntryId, companyId, token, formData).then((res) => {

                })
            } else {
                // navigate('/work-flow/view-circuler', { state: { objectDataToFullCirculerView: record } })
                navigate('/work-flow/view-circuler', { state: { tabValue: tabValue, approvalId: record._id } })
            }
        }
    };

    ////////----------------------------------------------------Handle Buttons ----------------------------------------------------------
    async function onClickApproveButton(data) {
        setNeedMoreInfoFieldsVisibility(true)
        setClickedObject(data)
        //showModal()
        showDrawer();
        setActionButtonType(1)
        setActionButtonName('Approve')
    }

    async function onClickRejectButton(data) {
        setNeedMoreInfoFieldsVisibility(true)
        setClickedObject(data)
        //showModal()
        showDrawer();
        setActionButtonType(2)
        setActionButtonName('Reject')
    }

    function setLevelListData(id, label, value) {

        return {
            id,
            label,
            value,
        };
    }

    async function onClickNeedMoreInfoButton(data) {
        var listOfObjects = [];

        var response = await WorkflowManagementAPI.getUserLevelList(data._id, data.parentEntryId, companyId, token).then((res) => {
            return res.data;
        })

        for (let i = 0; i < response.length; i++) {
            listOfObjects.push(
                setLevelListData(
                    i,
                    response[i]['approver']['name'],
                    response[i]['_id'],
                )
            )
        }
        setLevelList(listOfObjects)

        setClickedObject(data)
        setNeedMoreInfoFieldsVisibility(false)
        //showModal()
        showDrawer();
        setActionButtonType(3)
        setActionButtonName('Send')
    }

    const onFinish = async (values) => {
        //console.log('actionForm')
        setIsStateChanged(false)
        if (values.comment == undefined) {
            values.comment = ''
        }

        var formData = {};


        if (actionButtontype == 1) {
            formData = {
                "response": "approve",
                "comment": values.comment,
            }

            if (values.comment != '') {
                const formDataPass = new FormData();
                if(fileList.length > 0){
                    for (let i = 0; i < fileList.length; i++) {
                        formDataPass.append("files", fileList[i].file);
                    }
                }else{
                    formDataPass.append("files", null);

                }
                formDataPass.append("comment", values.comment);

                formDataPass.append("commentType", "approved");

                await WorkflowManagementAPI.postComments(clickedObject._id, companyId, token, formDataPass).then((res) => {
                    //console.log(res)
                    //setIsStateChanged(true)
                })
            }
        }
        else if (actionButtontype == 2) {
            formData = {
                "response": "reject",
                "comment": values.comment,
            }

            if (values.comment != '') {
                const formDataPass = new FormData();
                if(fileList.length > 0){
                    for (let i = 0; i < fileList.length; i++) {
                        formDataPass.append("files", fileList[i].file);
                    }
                }else{
                    formDataPass.append("files", null);

                }
                formDataPass.append("comment", values.comment);

                formDataPass.append("commentType", "rejected");

                await WorkflowManagementAPI.postComments(clickedObject._id, companyId, token, formDataPass).then((res) => {
                    //console.log(res).
                    //setIsStateChanged(true)
                })
            }
        }
        else if (actionButtontype == 3) {
            formData = {
                "response": "needMoreInfo",
                "comment": values.comment,
                "targetApproverEntryId": values.targetApproverEntryId
            }
        }


        var res = await WorkflowManagementAPI.approve(clickedObject._id, clickedObject.parentEntryId, companyId, token, formData).then((res) => {
            //console.log(res)
            setIsStateChanged(true)
        })
        setActionButtonType(0)
        //handleCancel()
        handleClose();
    };

    const props = {
        name: "file",
            multiple: true,
            beforeUpload(file) {
            if(file.type !== "application/pdf"){
                // message.error("only PDF files are allowed.");
                openNotification('error', 'Error', `only PDF files are allowed.`, 'bottomLeft');

                return false;
            }
            let date = new Date().toISOString().split('T')[0];
            const obj = {
                key: count,
                name: file.name,
                file: file,
                added: date
            };
            setFileList((prev) => [...prev, obj]);
            setCount(count + 1);
            // message.success(`${file.name} added to the list.`);
            openNotification('success', 'Success', `${file.name} added to the list.`, 'bottomLeft');

            return false;
            },
            onRemove(file) {
            setFileList((prev) => prev.filter((item) => item.key !== file.key));
            setCount(count - 1);
            // message.info(`${file.name} removed.`);
            openNotification('info', 'Info', `${file.name}removed.`, 'bottomLeft');
            },
            onDrop(e) {
            console.log("Dropped files:", e.dataTransfer.files);
            },
    };

    useEffect(() => {
        handleSearchFunction(searchText)
    }, [searchText])

    const handleSearchFunction = (value) => {
        if (value) {
            const filteredData = payload.filter(item =>
                item.subject.toLowerCase().includes(value.toLowerCase()) ||
                item.createdBy.name.toLowerCase().includes(value.toLowerCase()) ||
                item.requestType.requestType.toLowerCase().includes(value.toLowerCase())
            );
            setTempToDoData(filteredData);
        } else {
            setTempToDoData(payload)
        }
    }

    return (
        <>
        {contextHolder}
        {
            isToDoListLoading ? (<>
                <CommonSkeletonLoader itemCount={2} />
            </>) : (<>
                <Table
                    //dataSource={payload}
                    dataSource={tempToDoData}
                    columns={columns}
                    pagination={false}
                    onRow={(record) => ({

                        onClick: (e) => {
                            const cell = e.target.closest('td');
                            const row = cell.parentElement;
                            handleRowClick(record, cell.cellIndex);
                        },
                    })}
                    style={{
                        cursor: 'pointer', 
                    }}
                />
            </>)
        }
            <>
                <Drawer
                    title={
                        actionButtonName === 'Send' ? 'Need More Information ?' :
                            actionButtonName === 'Approve' ? 'Approve Circuler' :
                                actionButtonName === 'Reject' ? 'Reject Circuler' :
                                    'Comment'  // default title
                    }
                    open={isDrawerOpen}
                    onClose={handleClose}
                    destroyOnClose
                    footer={
                        <Flex align='center' justify='flex-end' gap={16}>
                            <Button onClick={handleClose}>Cancel</Button>
                            <Button
                                type='primary'
                                onClick={() => actionForm.submit()}
                                danger={actionButtonName === 'Reject'}
                            >
                                {actionButtonName}
                            </Button>
                        </Flex>
                    }
                >
                    <>
                        <Form
                            form={actionForm}
                            onFinish={onFinish}
                            layout="vertical">
                            {!needMoreInfoFieldsVisibility && (
                                <Text
                                    type="secondary"
                                    disabled={needMoreInfoFieldsVisibility}
                                >
                                    If you need more info, select level or user and add your comment and request details:
                                    <br />
                                    <br />
                                </Text>
                            )}
                            {needMoreInfoFieldsVisibility == false && (
                                <Form.Item
                                    label="Select Level"
                                    placeholder="Select a level"
                                    //disabled={needMoreInfoFieldsVisibility}
                                    //style={{ display: !needMoreInfoFieldsVisibility ? 'inline-block' : 'none' }}
                                    name="targetApproverEntryId"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Select a User',
                                        }
                                    ]}
                                >
                                    <Select
                                        placeholder="Select a level or user"
                                        //disabled={needMoreInfoFieldsVisibility}
                                        //style={{ display: !needMoreInfoFieldsVisibility ? 'inline-block' : 'none' }}
                                        options={levelList}
                                    />
                                </Form.Item >
                            )}
                            <Form.Item
                                label="Add Comment"
                                name="comment"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Add a Comment',
                                    }
                                ]}
                            >
                                <TextArea rows={3} placeholder="Enter your comment here" />
                            </Form.Item>
                        </Form>
                    </>
                    {needMoreInfoFieldsVisibility && (
                        <div>
                            <Dragger {...props} fileList={fileList}>
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>
                                <Text type='secondary' className="ant-upload-text">Click or drag file to this area to upload</Text>
                                <br />
                                <Text type='secondary' className="ant-upload-hint">
                                    Support for a single or bulk upload. Strictly prohibited from uploading company data or other
                                    banned files.
                                </Text>
                            </Dragger>
                        </div>
                    )
                    }
                </Drawer>
            </>

            {/* <>
                <Modal
                    title="Comment"
                    open={isModalOpen}
                    onCancel={handleCancel} footer={false}>
                    <>
                        <Form
                            form={actionForm}
                            onFinish={onFinish}
                            layout="vertical">
                            {!needMoreInfoFieldsVisibility && (
                                <Text
                                    type="secondary"
                                    disabled={needMoreInfoFieldsVisibility}
                                >
                                    If you need more info, select level or user and add your comment and request details:
                                    <br />
                                    <br />
                                </Text>
                            )}
                            {needMoreInfoFieldsVisibility == false && (
                                <Form.Item
                                    label="Select Level"
                                    placeholder="Select a level"
                                    //disabled={needMoreInfoFieldsVisibility}
                                    //style={{ display: !needMoreInfoFieldsVisibility ? 'inline-block' : 'none' }}
                                    name="targetApproverEntryId"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Select a User',
                                        }
                                    ]}
                                >
                                    <Select
                                        placeholder="Select a level or user"
                                        //disabled={needMoreInfoFieldsVisibility}
                                        //style={{ display: !needMoreInfoFieldsVisibility ? 'inline-block' : 'none' }}
                                        options={levelList}
                                    />
                                </Form.Item >
                            )}
                            <Form.Item
                                label="Add Comment"
                                name="comment"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Add a Comment',
                                    }
                                ]}
                            >
                                <TextArea rows={3} placeholder="Enter your comment here" />
                            </Form.Item>
                        </Form>
                    </>
                    <br></br>
                    <>
                        <Upload {...props}>
                            <Button style={{ display: needMoreInfoFieldsVisibility ? 'inline-block' : 'none' }} icon={<UploadOutlined />}>Click to Upload Files</Button>
                        </Upload>
                    </>
                </Modal>
            </> */}
        </>
    );
}
